const state = {
  register_schema: {},
};

const mutations = {
  SET_REGISTER_SCHEMA(state, payload) {
    state.register_schema = payload;
  },
};

const getters = {
  getRegisterSchema: (state) => {
    return state.register_schema;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
